import icons from "../../assets/images/sprite-other-icons.svg";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import { useDispatch, useSelector } from "react-redux";
import { handleLogout } from "../changePin/cl_ChangePinSlice";
import Wallet from "../../assets/images/wallet .svg";
import BonusGift from "../../assets/images/bonus.svg";
import Coin from "../../assets/images/coin.svg";
import { setIsSideMenuOpened } from "../signUp/cl_SignUpSlice";
import { getUserDetails, getUserLoyalty } from "../signIn/cl_SignInSlice";
import LoyaltyConfig from "../../assets/loyaltyPointsConfig.json";
import { RedeemModal } from "../fasfasCoins/RedeemModal";
import { setIsmodalOpen, setShowRedeemPopUp } from "../home/cl_LoyalltyCoins";

function SideMenuBar({ setIsMenuOpen, isMenuOpen, buttonRef }) {
  const [IsOpen, setIsOpen] = useState(false);
  const [IsBonusDropDownOpen, setIsBonusDropDownOpen] = useState(false);
  const [balDropDown, setBalDropDown] = useState(false);
  const [showRedeemModal, setShowRedeemModal] = useState(false);
  const { balance, userDetails, balanceDetails, userLoyalty } = useSelector(
    (state) => state?.signIn
  );
  // console.log("userLoyalty: ", userLoyalty?.level);
  const menuRef = useRef(null);
  const [bonusAccordion, setBonusAccordion] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = getFromLocalStorage("gk");

  const navigateTo = (route) => {
    dispatch(setIsSideMenuOpened(false));
    navigate(`/${route}`);
  };

  const logout = () => {
    dispatch(handleLogout(token, navigate));
    dispatch(setIsSideMenuOpened(false));
    dispatch(setIsmodalOpen(false));
  };
  const dropdownOpen = () => {
    setIsOpen(!IsOpen);
  };
  const handleBonusdropDown = () => {
    setIsBonusDropDownOpen(!IsBonusDropDownOpen);
  };

  const freeGamesCount = balanceDetails?.bonus_summary?.result?.data?.freeSpinCount;

  useEffect(() => {
    if (userDetails?.userId) {
      //dispatch(getUserLoyalty(userDetails?.userId))
    }
  }, [userDetails?.userId]);
  const handleClickOutside = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      !buttonRef.current.contains(event.target)
    ) {
      setIsMenuOpen(false);
      dispatch(setIsSideMenuOpened(false));
    }
  };

  const redeemCoin = () => {
    let errorMsg = "";

    if (!burnCoins || burnCoins > userLoyalty.coins) {
      const currentLevel =
        LoyaltyConfig.loyaltyPointsConfig[1]?.loyaltyLevels.find(
          (data) => userLoyalty.level === data.level
        );

      if (currentLevel) {
        const maxCoins =
          currentLevel.level === "level4"
            ? userLoyalty?.coins
              ? Math.floor(userLoyalty?.coins)
              : 0
            : currentLevel.maxBurnCoins;

        errorMsg = `Please enter value less than ${maxCoins} coins`;
      }
    } else {
      LoyaltyConfig.loyaltyPointsConfig[1]?.loyaltyLevels.forEach((data) => {
        if (userLoyalty.level === data.level) {
          if (data?.level === "level4") {
            setMinMaxValue(
              `(Min ${Number(data.minBurnCoins).toLocaleString()} Coins - Max ${userLoyalty?.coins ? Math.floor(userLoyalty?.coins).toLocaleString() : 0
              } Coins)`
            );
          } else {
            setMinMaxValue(
              `(Min ${Number(data.minBurnCoins).toLocaleString()} Coins - Max ${Number(data.maxBurnCoins).toLocaleString()} Coins)`
            );
          }
          if (data.level === "level4") {
            if (burnCoins < data.minBurnCoins) {
              errorMsg = `Please enter a value greater than ${data.minBurnCoins - 1
                } coins`;
            } else if (burnCoins > userLoyalty?.coins) {
              errorMsg = `Please enter a value less than ${userLoyalty?.coins ? Math.floor(userLoyalty?.coins).toLocaleString() : 0
                } coins`;
            }
          } else if (burnCoins < data.minBurnCoins) {
            errorMsg = `Please enter a value greater than ${data.minBurnCoins - 1
              } coins`;
          } else if (burnCoins > data.maxBurnCoins) {
            errorMsg = `Please enter a value less than ${data.maxBurnCoins + 1
              } coins`;
          }
        }
      });
    }
    if (errorMsg) {
      dispatch(setShowRedeemPopUp(false));
    } else {
      setShowRedeemModal(false);
      dispatch(setShowRedeemPopUp(true));
    }
    setErrorMessage(errorMsg);
  };

  useEffect(() => {
    LoyaltyConfig.loyaltyPointsConfig[1]?.loyaltyLevels.forEach((data) => {
      if (userLoyalty?.level === data?.level) {
        if (data?.level === "level4") {
          setMinMaxValue(
            `(Min ${Number(data.minBurnCoins).toLocaleString()} Coins - Max ${userLoyalty?.coins ? Math.floor(userLoyalty?.coins).toLocaleString() : 0
            } Coins)`
          );
        } else {
          setMinMaxValue(
            `(Min ${Number(data.minBurnCoins).toLocaleString()} Coins - Max ${Number(data.maxBurnCoins).toLocaleString()} Coins)`
          );
        }
        setPerMinMaxValue(
          data?.levelCutoff ? data?.levelCutoff : data?.levelEntry
        );
      }
    });
  }, [userLoyalty?.level, userLoyalty?.coins]);

  const balenceCoins = userLoyalty?.coins > 0 ? userLoyalty?.coins : 0;
  const { coinsHistoryData } = useSelector((state) => state.coinsHistory);
  const filteredData =
    coinsHistoryData &&
    coinsHistoryData?.filter((item) => item.loyaltyType === "burn");
  const levelIndex = parseInt(userLoyalty?.level?.replace("level", ""));
  const minBurnCoins =
    LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[levelIndex]
      ?.minBurnCoins;
  const [minMaxValues, setMinMaxValue] = useState("");

  const { isModalOpen, showRedeemPopUp } = useSelector(
    (state) => state?.coinsHistory
  );
  const [perMaxValues, setPerMinMaxValue] = useState("");
  const [burnCoins, setBurnCoins] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const handleChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[+-]+/, "");
    const re = /^[0-9]*$/;
    if (re.test(inputValue)) {
      setBurnCoins(inputValue);
    }

    setErrorMessage("");
  };
  const handleKeyDown = (e) => {
    if (e.key === "+" || e.key === "-") {
      e.preventDefault();
    }
  };

  useEffect(() => {
    dispatch(getUserDetails());
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);
  return (
    <React.Fragment>
      {isMenuOpen && (
        <div className="SB-dropdown-menu" ref={menuRef}>
          <div id="page-header-myAccountMenu">
            <div className="SB-myAccountMenu-container">
              <div className="SB-myAccountMenu-close-container">
                <div
                  className="SB-myAccountMenu-closeButton"
                  id="SB-myAccountMenu-closeButton"
                  onClick={() => {
                    setIsMenuOpen(false);
                    dispatch(setIsSideMenuOpened(false));
                  }}
                >
                  Close
                  <div className="SB-iconSVG">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#${"icon-close"}`} />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="SB-myAccountBalance-container">
                <div className="SB-userMobileNumber d-none">
                  <b id="userPhoneNumber">
                    {userDetails?.userOtherInfo?.phone}
                  </b>
                </div>
                <div className="SB-userProfile">
                  <div className="SB-usericon">
                    <div className="SB-icon-container">
                      <div className="SB-iconSVG" title="user">
                        {userLoyalty?.lifeTimeCoins <=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                            .levelCutoff ? (
                          <img
                            src={require("../../assets/images/loyalty/dash.webp")}
                            alt="dash"
                          />
                        ) : userLoyalty?.lifeTimeCoins <=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                            .levelCutoff ? (
                          <img
                            src={require("../../assets/images/loyalty/sprint.webp")}
                            alt="sprint"
                          />
                        ) : userLoyalty?.lifeTimeCoins <=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                            .levelCutoff ? (
                          <img
                            src={require("../../assets/images/loyalty/surge.webp")}
                            alt="surge"
                          />
                        ) : userLoyalty?.lifeTimeCoins <=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                            .levelEntry ? (
                          <img
                            src={require("../../assets/images/loyalty/thrill.webp")}
                            alt="thrill"
                          />
                        ) : userLoyalty?.lifeTimeCoins >=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                            .levelEntry ? (
                          <img
                            src={require("../../assets/images/loyalty/boss.webp")}
                            alt="boss"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="SB-userDetails">
                    <div className="SB-userName d-none">
                      {userDetails?.userName}
                    </div>
                    <div className="SB-userNumber">
                      {userDetails?.userOtherInfo?.phone}
                    </div>
                  </div>
                </div>

                <div
                  className={`SB-accordion SB-userBalanceSection ${balDropDown ? "" : "collapsed"
                    }`}
                >
                  <div
                    className="SB-accordion-header SB-arrowAfter"
                    onClick={() => setBalDropDown(!balDropDown)}
                  >
                    <div className="SB-contentBlock">
                      <div className="SB-leftContent">
                        <div className="SB-balanceLabel">Cash Balance</div>
                      </div>
                      <div className="SB-rightContent">
                        <div className="SB-userBalance SB-txtHighlight">
                          <img src={Wallet} alt="wallet" />
                          <b id="userBalanceAmount">
                            KES {balanceDetails?.real_balance?.result?.balance.toLocaleString()}
                          </b>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="SB-accordion-content">
                    <div className="SB-contentBlock">
                      <div className="SB-leftContent">
                        <div className="SB-balanceLabel">
                          Withdrawable Balance
                        </div>
                      </div>
                      <div className="SB-rightContent">
                        <div className="SB-userBalance">
                          KES {balanceDetails?.real_balance?.result?.withdrawls.toLocaleString()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="SB-accordion SB-userBalanceSection collapsed d-none">
                  <div
                    className="SB-accordion-header SB-arrowAfter"
                    onClick={dropdownOpen}
                  ></div>
                </div>

                {/* <div className='SB-userBonusSection'> */}
                <div
                  className={`SB-accordion SB-casinoBonusBlock ${bonusAccordion ? "" : "collapsed"
                    }`}
                  onClick={() => setBonusAccordion(!bonusAccordion)}
                >
                  <div className="SB-accordion-header SB-arrowAfter">
                    <div className="SB-contentBlock">
                      <div className="SB-leftContent">Bonus</div>
                      <div className="SB-rightContent" id="unLockedBonus">
                        <img src={BonusGift} alt="bonus" />{" "}
                        {
                          balanceDetails?.bonus_summary?.result?.data
                            ?.lockedBonus
                        }
                      </div>
                    </div>
                  </div>
                  <div className="SB-accordion-content">
                    <div className="SB-contentBlock">
                      <div className="SB-leftContent">Games locked Bonus</div>
                      <div className="SB-rightContent" id="casinoLockedBonus">
                        {
                          balanceDetails?.bonus_summary?.result?.data
                            ?.lockedBonus
                        }
                      </div>
                    </div>
                    {/* <div className="SB-contentBlock">
                      <div className="SB-leftContent">Games unlocked Bonus</div>
                      <div className="SB-rightContent" id="casinoUnLockedBonus">
                        {
                          balanceDetails?.bonus_summary?.result?.data
                            ?.unLockedBonus
                        }
                      </div>
                    </div> */}
                  </div>
                </div>
                {/* </div> */}
                <div className="SB-userCoinsBalance">
                  <div className="SB-coinsItem SB-coinsBalance">
                    <div className="SB-coinsItem-label">
                      FasFas Coins Balance
                    </div>
                    <div className="SB-redeemCoins">
                      <div className="SB-btnContainer">
                        {userLoyalty?.coins
                          ? Math.floor(userLoyalty?.coins) >= minBurnCoins && (
                            <button
                              className="btn SB-btnSecondary active SB-btnredeem"
                              onClick={() => setShowRedeemModal(true)}
                            >
                              Redeem
                            </button>
                          )
                          : ""}
                      </div>
                      <div className="SB-coinsItem-value">
                        <img src={Coin} alt="coin" />
                        <span>
                          {userLoyalty?.coins
                            ? Math.floor(userLoyalty?.coins).toLocaleString()
                            : 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="SB-userCoinsBalance">
                  <div className="SB-coinsItem SB-coinsBalance">
                    <div className="SB-coinsItem-label">Free Game Count</div>
                    <div className="SB-redeemCoins">
                      <div className="SB-coinsItem-value">
                        <span>
                          {freeGamesCount
                            ? Math.floor(freeGamesCount)
                            : 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {showRedeemModal && userLoyalty?.coins ? (
                  Math.floor(userLoyalty?.coins) >= minBurnCoins ? (
                    <div className="SB-modal SB-modal-fullscreen SB-burnCoins-modal open">
                      <div className="SB-modal-dialog">
                        <div className="SB-modal-content">
                          <div
                            className="SB-modal-close"
                            onClick={() => {
                              setShowRedeemModal(false);
                              setBurnCoins("");
                              setErrorMessage("");
                            }}
                          >
                            <div className="SB-iconSVG" title="close">
                              <svg xmlns="http://www.w3.org/2000/svg">
                                <use xlinkHref={`${icons}#icon-close`} />
                              </svg>
                            </div>
                          </div>
                          <div className="SB-modal-body">
                            <div className="SB-myAccount-sectionBox SB-burnCoins">
                              <div className="SB-myAccount-sectionBox_content">
                                <p className="SB-burnCoins-text SB-title">
                                  You can burn Fasfas Coins now for an exchange
                                  of surprise Instant Cash
                                </p>
                                <div className="SB-form-group">
                                  <div className="SB-form-label">
                                    <span>Enter Fasfas Coins to burn</span>
                                    <span className="SB-coinsMinMax">
                                      {minMaxValues}
                                    </span>
                                  </div>
                                  <div className="SB-form-control">
                                    <input
                                      type="text"
                                      value={burnCoins}
                                      onChange={handleChange}
                                      onKeyDown={handleKeyDown}
                                      placeholder="Enter Coins Here"
                                      maxLength={10}
                                    />
                                  </div>
                                  <div className="SB-form-errorMsg">
                                    {errorMessage && (
                                      <span>{errorMessage}</span>
                                    )}
                                  </div>
                                </div>
                                <div className="SB-btnContainer">
                                  <button
                                    className="btn SB-btnSecondary active SB-btncoinsBurnNow"
                                    data-toggle="modal"
                                    data-target="SB-burnNowCoins-modal"
                                    onClick={redeemCoin}
                                  >
                                    Burn Now
                                  </button>
                                </div>
                                <p className="SB-burnCoins-text SB-instantCash">
                                  You will get Instant Cashback credited to your
                                  wallet immediately
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                {showRedeemPopUp && (
                  <RedeemModal coins={burnCoins} setBurnCoins={setBurnCoins} />
                )}

                <div className="SB-btnContainer">
                  <button
                    className="btn SB-btnSecondary SB-btnMedium active SB-btnDepositMyAccount"
                    onClick={() => navigateTo("deposit")}
                  >
                    Deposit
                  </button>
                  <button
                    className="btn SB-btnSecondary SB-btnMedium active SB-btnWithdrawMyAccount"
                    onClick={() => navigateTo("withdraw")}
                  >
                    Withdraw
                  </button>
                </div>
              </div>

              <div className="SB-myAccountLinks-container">
                <div className="SB-myAccount-highlightList">
                  <ul>
                    <li>
                      <div
                        className="SB-myAccount-highlightList-item"
                        onClick={() => navigateTo("loyalty")}
                      >
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${"icon-loyalty"}`} />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Loyalty
                        </div>
                      </div>
                    </li>
                    <li className="d-none">
                      <div className="SB-myAccount-highlightList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG" title="leaderboard">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-leaderboard"}`}
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          LeaderBoard
                        </div>
                      </div>
                    </li>
                    <li>
                      <div
                        className="SB-myAccount-highlightList-item"
                        onClick={() => navigateTo("fasfascoins")}
                      >
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG" title="coins">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${"icon-coins"}`} />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Coins
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="SB-myAccountList">
                  <ul>
                    <li
                      onClick={() => navigateTo("about")}
                      className="aboutusItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="aboutus">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${"icon-aboutus"}`} />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          About Us
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li
                      onClick={() => navigateTo("bethistory")}
                      className="betHistoryItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="Bet history">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-bet-history"}`}
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Game History
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      className="coinsHistoryItem"
                      onClick={() => navigateTo("coins-history")}
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="loyalty">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-coins-history"}`}
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          FasFas Coins History
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG" title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      onClick={() => navigateTo("accounthistory")}
                      className="accountHistoryItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="Account History">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-account-history"}`}
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          className="SB-myAccountList-item-content"
                          onClick={() => navigateTo("accounthistory")}
                        >
                          Account History
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      onClick={() => navigateTo("mybonuses")}
                      className="accountHistoryItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="Account History">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${"icon-bonus"}`} />
                            </svg>
                          </div>
                        </div>
                        <div
                          className="SB-myAccountList-item-content"
                          onClick={() => navigateTo("mybonuses")}
                        >
                          My Bonuses
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li className="bonusUsageItem d-none">
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="Bonus History">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref="images/sprite-other-icons.svg#icon-bonus"></use>
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Bonus Usage
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      onClick={() => navigateTo("profile")}
                      className="accountDetailsItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="Account Details">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-account-details"}`}
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Profile
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    {userLoyalty?.level === "level4" ? null : (
                      <li
                        className="referAndEarn"
                        onClick={() => navigateTo("refer")}
                      >
                        <div className="SB-myAccountList-item">
                          <div className="SB-icon-container">
                            <div className="SB-iconSVG " title="Refer A Friend">
                              <svg xmlns="http://www.w3.org/2000/svg">
                                <use
                                  xlinkHref={`${icons}#${"icon-referAFriend"}`}
                                />
                              </svg>
                            </div>
                          </div>

                          <div className="SB-myAccountList-item-content">
                            Refer and Earn
                          </div>

                          <div className="SB-arrow-container">
                            <div className="SB-iconSVG " title="Arrow Right">
                              <svg xmlns="http://www.w3.org/2000/svg">
                                <use
                                  xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </li>
                    )}

                    <li
                      className="changePinItem"
                      onClick={() => navigateTo("change-pin")}
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG" title="Change PIN">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-change-pin"}`}
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Change PIN
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li
                      onClick={() => navigateTo("selfexclusion")}
                      className="accountDetailsItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="Account Details">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${"icon-info"}`} />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Responsible Gambling
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="">
                <a href="edit-account.html">
                  <button
                    className="btn SB-btnDefault SB-btnMedium SB-btnEditAccountInfo"
                    style={{ display: "none" }}
                  >
                    Edit Account Info
                  </button>
                </a>
              </div>
              <div className="SB-myAccount-logout-container">
                <button
                  className="btn SB-btnQuaternary active SB-btnMedium SB-btnLogout"
                  onClick={logout}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default SideMenuBar;
